module.exports = __webpack_public_path__ + "muli-bolditalic-webfont.asset.b9307c6573997c1da4d1487c97e22090.woff";